/* The timezone the portal displays times in, and computes "today" in.

   Set once from the tenant's configured timezone (which the backend reads from
   VitalPBX) as the session loads. This is the customer's business timezone, so
   times on screen and the date filters both line up with how the PBX stores
   and filters call dates — no midnight-boundary drift.

   Until it's set (and if the tenant timezone is somehow unknown) it falls back
   to the viewer's own browser timezone, which is a sensible default. */

let zone = null;

export function setTimeZone(tz) {
  zone = tz || null;
}

export function getTimeZone() {
  return zone || browserTimeZone();
}

export function browserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

/* Intl.DateTimeFormat instances are relatively costly to build, so cache them
   per (timezone, options-key). Keyed by the current zone so switching zones
   just misses the cache rather than serving stale formatters. */
const cache = new Map();

export function formatter(key, options) {
  const tz = getTimeZone();
  const cacheKey = tz + '|' + key;
  let f = cache.get(cacheKey);
  if (!f) {
    f = new Intl.DateTimeFormat('en-GB', { ...options, timeZone: tz });
    cache.set(cacheKey, f);
  }
  return f;
}

/** YYYY-MM-DD for an instant, in the display timezone. en-CA gives that order. */
const YMD_OPTS = { year: 'numeric', month: '2-digit', day: '2-digit' };
export function ymd(date) {
  // en-CA formats as YYYY-MM-DD; build a dedicated formatter for it.
  const tz = getTimeZone();
  const cacheKey = tz + '|ymd';
  let f = cache.get(cacheKey);
  if (!f) {
    f = new Intl.DateTimeFormat('en-CA', { ...YMD_OPTS, timeZone: tz });
    cache.set(cacheKey, f);
  }
  return f.format(date);
}
